import { useNavigate } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { TemplatesList } from "@/components/templates/TemplatesList";
import { Button } from "@/components/ui/button";

export function TemplatesPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Templates"
        description="Manage audit templates for your adherence program."
        actions={
          <Button onClick={() => navigate({ to: "/dashboard/templates/new" })}>
            <Plus className="h-4 w-4 mr-1" />
            New Template
          </Button>
        }
      />
      <TemplatesList />
    </div>
  );
}
